import styled from "styled-components";

export const controlSizeStyle = {
	n: "",
	sm: `padding: 4.5px 1.5px 4.5px 3px !important;`,
	xsm: `font-size: 11px;
			font-weight: 400;
			padding: 3px 5px;
			border-radius: 4px;
			height: 20px;`,
};

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    max-width: 100%;
    min-width: 90px;
`;

export const LabelContainer = styled.div<{ $isDisabled?: boolean }>`
	font-size: 1rem;
	font-weight: 500;
	white-space: nowrap;

	${({ $isDisabled }) =>
		$isDisabled &&
		`cursor: not-allowed;
		opacity: 0.5;`}

	color: ${({ theme }) => theme.colors.textPrimary};
`;

export const InputContainer = styled.div<{ $disableBorder?: boolean; $inputStatus?: "none" | "success" | "error" }>`
	max-width: 100%;
	display: flex;
	align-items: center;
	border-radius: 4px;

	${({ $disableBorder }) =>
		$disableBorder &&
		`border: none !important;
			gap: 0px;`}

	color: ${({ theme }) => theme.colors.textInput};
	background-color: ${({ theme }) => theme.colors.backgroundInput};
	border: 1px solid #d0d1d3;

	${({ $inputStatus, theme }) => $inputStatus === "error" && `border-color: ${theme.colors.inputError}`}
`;

export const InputPrefix = styled.div<{ $isDisabled?: boolean }>`
	color: ${({ theme }) => theme.colors.textPrimary};

	${({ $isDisabled }) => $isDisabled && "opacity: 0.5;"}

	padding-left: 6px;
	font-size: 1.2rem;
`;

export const CustomInput = styled.input<{
	$inputType?: "text" | "number" | "checkbox" | "password" | "date";
	$controlSize?: "n" | "sm" | "xsm";
}>`
	font-size: 1.2rem;
	padding: 6px 10px;
	width: 100%;
	box-sizing: border-box;
	min-width: 0;
	flex: 1 1 auto;
	border-radius: 3px;
	background-color: transparent;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	border: none;
	outline: none;

	color: ${({ theme }) => theme.colors.textPrimary};

	&::placeholder {
		color: ${({ theme }) => theme.colors.inputPlaceholder};
	}

	${({ $controlSize }) => $controlSize && controlSizeStyle[$controlSize]}

	${({ $controlSize, $inputType }) => $controlSize === "xsm" && $inputType === "date" && "padding: 3px 2px;"}
`;

export const InputIcons = styled.div<{ $isDisabled?: boolean }>`
	${({ $isDisabled }) =>
		$isDisabled &&
		`cursor: not-allowed;
		opacity: 0.3;
		pointer-events: none;`}

	align-items: center;
	align-self: stretch;
	display: flex;
	gap: 4px;
	padding: 0px 4px 0px 0px;
`;

export const XIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	align-self: stretch;
`;

export const StatusContainer = styled.div<{ $inputStatus: "none" | "success" | "error" }>`
	font-size: 11px;

	color: ${({ theme }) => theme.colors.inputError};
	${({ $inputStatus, theme }) => $inputStatus === "error" && `border-color: ${theme.colors.inputError}`}
`;
